module.exports = __webpack_public_path__ + "fonts/ae612f570fc550ab6195bb5d07c82598.svg";